
    import './styles.scoped.css';
    export default {
  "placeholder": "_placeholder_f66qq_3",
  "item": "_item_f66qq_8",
  "checkbox": "_checkbox_f66qq_12",
  "filter": "_filter_f66qq_21",
  "trigger": "_trigger_f66qq_25"
};
  